import Column from '@able/react/dist/Column'
import Grid from '@able/react/dist/Grid'
import './style.less'

export const MDUMPageWrapper = ({children, pageClassName}) => {
  return (
    <div className={`tc-mobility`}>
      <div
        className={`container mobility-page-content mobility-${pageClassName} ui-mobility-${pageClassName}`}
      >
        {children}
      </div>
    </div>
  )
}

export const MobilityPageWrapper = ({children, pageClassName}) => {
  const className = `mobility-page-content mobility-${pageClassName} ui-mobility-${pageClassName}`
  return (
    <div className={`tc-mobility`}>
      <div className={className}>{children}</div>
    </div>
  )
}
export const MDUMPageWrapperAble = ({children, pageClassName}) => {
  return (
    <Grid padding={false} className={`tc-mobility`}>
      <Column
        className={`mobility-${pageClassName} ui-mobility-${pageClassName} able-Spacing able-Spacing--top--spacing7x`}
      >
        {children}
      </Column>
    </Grid>
  )
}
